// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"7a8f1ea6","261":"4dc396c2","338":"6a59f0ce","456":"496b8115","541":"d408ff5d","544":"a203e133","576":"95d99cae","753":"8632d4d4","775":"d2500f6a","823":"7d61ed0e","980":"342285e1"}[chunkId] + ".js";
};